The URI to redirect to for verification.
